import * as _ from 'lodash';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import { Formatter } from 'slickgrid';

export interface DateFormatterOptions {
  format?: string;
}

export function date<T>(opts: DateFormatterOptions): Formatter<T> {
  const fmt = opts.format || 'yyyy-MM-dd';

  return function dateFormatter(row, cell, value, columnDef, data) {
    if (_.isString(value)) {
      value = parseISO(value);
    }
    return value ? format(value, fmt) : '';
  };
}
